<template>
  <div class="layout-page">
    <Layout class="layout-div">
      <Sider ref="side1" hide-trigger collapsible :collapsed-width="78" :width="230" v-model="isCollapsed" :class="themeType === 'light' ? 'themeLight' : 'themeDark'">
        <!--:class="isCollapsed?'collapsed_left':''"-->
        <div class="logo" :class="headMaxWidth ?'headMaxWidth' : ''" :style="{textAlign: isCollapsed ? 'center': 'left', paddingLeft: isCollapsed ? '0': '24px','cursor':'default'}">
          <!-- <img v-if="!isCollapsed && headMaxWidth" :src="headMaxWidthLogoImg" alt=""> -->
          <img v-if="companyLogo" :src="companyLogo" alt="" />
          <img v-else src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/default_icon.png" alt="" />
        </div>
        <Menu width="auto" accordion ref="side_menu" :active-name="activeName" :theme="themeType" :class="menuitemClasses" :open-names="openNames" @on-select="menuNav" @on-open-change="open">
          <Submenu v-for="(item, index) in routersArr" :key="index" v-if="!isCollapsed && !item.meta.hide && !item.meta.singlePage" :name="item.name">
            <template slot="title" v-if="!isCollapsed">
              <i :class="`iconfont ${item.meta.icon}`"></i>
              <span class="titlespan">{{ item.meta.title }}</span>
            </template>
            <MenuItem v-if="!isCollapsed && !it.meta.hide" v-for="it in item.children" :key="it.name" :name="it.name">
            <span>{{ it.meta.title }}</span>
            </MenuItem>
          </Submenu>
          <!--如果只有一个子路由-->
          <MenuItem v-else-if="!isCollapsed && !item.meta.hide && item.meta.singlePage" class="ivu-menu-submenu" style="padding: 0 !important" v-for="it in item.children" :key="index" :class="{ liActive: $route.name === it.name }" :name="it.name">
          <div class="ivu-menu-submenu-title">
            <i :class="`iconfont ${item.meta.icon}`" :style="item.meta.style"></i>
            <span style="margin-left: 10px">{{ it.meta.title }}</span>
          </div>
          </MenuItem>
          <Dropdown v-for="(item, index) in routersArr" :key="index" class="menuSmall" v-if="isCollapsed && !item.meta.hide" @on-click="dropdownNav">
            <span :class="item.name === $route.meta.fuName ? 'active' : ''">
              <i :class="`iconfont ${item.meta.icon}`"></i>
            </span>
            <DropdownMenu slot="list">
              <template v-for="it in item.children">
                <DropdownItem v-if="!it.meta.hide" :key="it.name" :name="it.name" :selected="it.name === activeName">{{ it.meta.title }}</DropdownItem>
              </template>
            </DropdownMenu>
          </Dropdown>
        </Menu>
      </Sider>
      <Layout>
        <!--头部-->
        <Header class="header flexR" :style="{width: (isCollapsed?'calc(100% - 78px)':'calc(100% - 230px)') }">
          <div class="header_left flexR">
            <span v-if="isCollapsed"><i class="iconfont icon-icon-02zhankai" style="font-size: 18px;" @click="collapsedSider"></i></span>
            <span v-if="!isCollapsed"><i class="iconfont icon-icon-01shouhui" style="font-size: 18px;" @click="collapsedSider"></i></span>
            <!-- <span @click="refresh()">
              <Icon type="ios-refresh" size="24" style="padding-top: 2px;" />
            </span> -->
            <span>
              <Breadcrumb class="topNav">
                <BreadcrumbItem>首页</BreadcrumbItem>
                <BreadcrumbItem>{{ $route.meta.fuTitle }}</BreadcrumbItem>
                <BreadcrumbItem v-if="$route.meta.title !== $route.meta.fuTitle">{{ $route.meta.title }}</BreadcrumbItem>
              </Breadcrumb>
            </span>
          </div>
          <!--头部右边-->
          <div class="header_right flexR">
            <!-- <span>
              <Icon size="18" :type="isMaxWindow ? 'md-contract' : 'md-expand'" @click="maxWindow" />
            </span> -->
            <!-- <span>
              <Dropdown trigger="click">
                <Badge :count="3"><Icon type="ios-notifications-outline" size="20" /></Badge>
                <DropdownMenu slot="list"><message></message></DropdownMenu>
              </Dropdown>
            </span> -->
            <div v-if="companyEnterShow" @click="goCompanyRegister" role="alert" class="el-message el-message--warning el-message-fade-leave-active el-message-fade-leave-to" style="top: 44px !important; z-index: 2016;opacity:1;height:40px !important;cursor:pointer;margin-top:0"><i class="el-message__icon el-icon-warning"></i>
              <p class="el-message__content">您未完成企业认证，请尽快完成企业认证，享用我们的服务</p>
            </div>
            <iframe src="../../../customer.html" frameborder="0" height="30px" width="100px" scrolling="no"></iframe>
            <span v-if="companyEnterShow">
              <span @click="goCompanyRegister" style="font-weight: 400; color: #666; text-align: center; cursor: pointer;">企业认证</span>
            </span>
            <span>
              <Dropdown @on-click="personalSettings">
                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 310px;">
                  <a href="javascript:void(0)" style="color: #515A6E;">
                    <el-avatar v-if="$store.getters.userData.avatar" :src="$store.getters.userData.avatar" :size="28" style="vertical-align: -9px;" />
                    <img v-else class="ivu-avatar ivu-avatar-small" style="vertical-align: -7px;border-radius:4px"
                      src="data:image/jpeg;base64,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">
                    {{$store.getters.userData.nickname}}
                  </a>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="userCenter">用户中心</DropdownItem>
                  <!-- <DropdownItem name="sz">设置</DropdownItem> -->
                  <DropdownItem name="logout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </span>
            <!-- <span @click="optionDrawer = true">
              <Icon type="md-more" size="20" />
            </span> -->
          </div>
        </Header>

        <!-- 多页标签 -->
        <div v-if="isTabsShow" class="tabsNav flexR">
          <div class="xiala pointer" v-if="tabSwitch" @click="tabLeft">
            <Icon type="ios-arrow-back" size="16" />
          </div>
          <div class="left flexR" id="tabsNav">
            <div class="flexR" id="tabsDiv" :style="{ transform: transform }">
              <div class="pointer flexR" v-for="(item, index) in $store.getters.routerArr" :key="item + index">
                <span :class="activeName === item.name ? 'active' : ''" @click="tabNav(item.name)">
                  {{ item.meta.title }}
                </span>
                <Icon type="ios-close" size="24" v-if="item.name !== $indexPage" @click="tabNavClose(item, index)" />
                <Dropdown trigger="contextMenu" style="margin-left: 5px" @on-click="tabRightClick" @on-visible-change="tabRightStatus($event, item.name)">
                  <a href="javascript:void(0)">
                    <Icon type="ios-close" size="24" @click="tabNavClose(item, index)" />
                  </a>
                  <DropdownMenu slot="list" v-if="item.meta.status">
                    <DropdownItem :name="item.name + '/qt'">关闭其他</DropdownItem>
                    <DropdownItem :name="item.name + '/left'">关闭左侧</DropdownItem>
                    <DropdownItem :name="item.name + '/right'">关闭右侧</DropdownItem>
                    <DropdownItem :name="item.name + '/qb'">全部关闭</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="xiala pointer" v-if="tabSwitch" @click="tabRight">
            <Icon type="ios-arrow-forward" size="16" />
          </div>
          <div class="right">
            <Dropdown style="margin-left: 5px" @on-click="tabRightClick">
              <div class="xiala pointer">
                <Icon type="ios-arrow-down" />
              </div>
              <DropdownMenu slot="list">
                <DropdownItem name="qt">关闭其他</DropdownItem>
                <DropdownItem name="left">关闭左侧</DropdownItem>
                <DropdownItem name="right">关闭右侧</DropdownItem>
                <DropdownItem name="qb">全部关闭</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>

        <!-- 内容区 -->
        <Content id="main_content" class="main_content flexC" :style="{height: (!isTabsShow?'calc(100vh - 48px)':'calc(100vh - 108px)') }">
          <router-view v-if="isRouterViewShow"></router-view>
          <!-- <Footer></Footer> -->
          <!-- <el-popover placement="left" width="240" trigger="hover">
            <div style="color: #333; font-size: 16px;font-weight: 700; margin-bottom: 10px;">联系方式</div>
            <div style="line-height: 22px;">
              <p><span style="color: #8E97AE;">联系电话: </span><span style="color: #208bfd;">15257398272</span></p>
              <p><span style="color: #8E97AE;">联系邮箱: </span><span style="color: #208bfd;">cs@eline56.com</span></p>
            </div>
            <div slot="reference" class="contactBtn"><el-button type="primary" circle><i class="iconfont iconkefu1"></i></el-button></div>
          </el-popover> -->
        </Content>

        <!-- 配置 -->
        <Drawer v-model="optionDrawer" class="optionDrawer">
          <Divider slot="header" class="header">主题风格设置</Divider>
          <div class="flexR imgs">
            <Tooltip content="时尚酷黑" placement="top" transfer :class="themeType === 'dark' ? 'active' : ''">
              <img src="../../assets/main/nav-theme-dark.svg" @click="themeSwitch(0)" />
            </Tooltip>
            <Tooltip content="极简雅白" placement="top" transfer :class="themeType === 'light' ? 'active' : ''">
              <img src="../../assets/main/nav-theme-light.svg" @click="themeSwitch(1)" />
            </Tooltip>
          </div>
          <Divider class="otherDiv">其他设置</Divider>
          <div class="kaiguan flexR">
            <span>开启多页签</span>
            <i-switch v-model="isTabsShow" size="small" />
          </div>
          <div class="kaiguan flexR">
            <span>顶栏通顶</span>
            <i-switch v-model="headMaxWidth" size="small" />
          </div>
        </Drawer>
      </Layout>
    </Layout>

    <InvitationDialog v-if="inviteModal" :inviteModal="inviteModal" :inviteCode="inviteCode" :inviteinfo="inviteinfo" @close="close" />

  </div>
</template>

<script>
import message from "../message/message"
const lightImg = 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/ux_logo.png'
import { themeData } from "@/config/config"
import { GetRequest } from '@/api/config'
// import Footer from "@/components/footer/footer";
import InvitationDialog from "@/components/InvitationDialog"
import { mapGetters } from "vuex"
import { httpAjax,httpAgent } from "@/api/ajax"
import { constantRoutes } from "@/router/index"

export default {
  name: "main-page",
  components: {
    message,
    InvitationDialog,
    // Footer 
  },
  computed: {
    ...mapGetters(["routes"]),
    // 获取vuex 路由数据 用户tag多页签
    getRouterArrVuex () {
      return this.$store.getters.routerArr
    },
    // 收缩的图标
    rotateIcon () {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""]
    },
    // 导航收缩
    menuitemClasses () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""]
    },
  },
  data () {
    return {
      activeName: "", // 子导航选中的name
      isCollapsed: false, // 是否收缩
      isMaxWindow: false, // 是否最大化窗口
      routersArr: [], // 路由数据
      openNames: [], // 导航打开的父栏目
      transform: 0, // 导航左右方向移动距离
      tabSwitch: false, // 是否显示左右切换图标
      userData: {}, // 登录用户数据
      optionDrawer: false, // 是否显示配置抽屉
      themeType: themeData.themeType ? themeData.themeType : "dark", // 主题风格
      logoImg: themeData.themeType === "dark" ? 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/uifox-files/mainpic/pic/eline_logo.png' : '', // 主题logo图片
      isTabsShow: themeData.isTabsShow, // 是否显示多页签
      headMaxWidthLogoImg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/uifox-files/mainpic/pic/eline_logo.png', // 栏目是否通顶logo图片
      headMaxWidth: themeData.headMaxWidth, // 栏目是否通顶（最大宽度）
      isRouterViewShow: true, // 控制router-view的隐藏与展示


      companyEnterShow: false, //首页企业认证入口是否显示

      // 邀请链接
      inviteModal: false,
      inviteinfo: null,
      inviteCode: null,
      companyLogo: ''
    }
  },
  created () {
    this.setRouterArr()
    this.getVgmCarrier()
    this.getCpsCarrier()
    console.log(77777)
    const inviteCode = GetRequest().inviteCode ? GetRequest().inviteCode.split('#')[0] : null
    if (inviteCode) {
      this.inviteCode = inviteCode
      this.getInviteInfo(inviteCode)
    }

    //判断企业是否已认证
    httpAjax({
      url: `/services/company/currentCompany`,
      method: "get",
    }).then((response) => {
      if (response.success) {
        response.data != null ? (response.data.status == 20 ? this.companyEnterShow = false : this.companyEnterShow = true) : this.companyEnterShow = true
      }
    })
  },
  mounted () {
    // 如果没有权限 回到默认首页 防止错误地址程序崩溃 跳转非法路由
    // if (this.$route.meta.hide) {
    //   this.$router.push({
    //     name: this.$indexPage,
    //   });
    // }
    // 页面刷新后 保存打开的路由数据到本地存储
    window.addEventListener("unload", this.saveState)
    this.activeName = this.$route.name
    this.openNames = []
    this.openNames.push(this.$route.meta.fuName)
    this.$nextTick(() => {
      // 重新渲染导航
      if (this.$refs.side_menu) {
        this.$refs.side_menu.updateOpened()
        // this.$refs.side_menu.updateActiveName()
      }
    })
    this.getDomainInfo();
  },
  methods: {
    // 关闭弹窗 
    close () {
      this.inviteModal = false
    },
    // 获取邀请信息
    getInviteInfo () {
      console.log(inviteCode)
      httpAjax({
        url: `/services/company/invite/${inviteCode}/info`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.inviteinfo = response.data
          this.inviteModal = true
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      })
    },
    toHome () {
      this.$router.push({ name: 'login' })
      this.type = 0
      sessionStorage.removeItem("tabIndex")
    },
    // 收缩切换
    collapsedSider () {
      this.$refs.side1.toggleCollapse()
      this.$nextTick(() => {
        // 重新渲染导航
        this.$refs.side_menu.updateOpened()
        this.$refs.side_menu.updateActiveName()
      })
    },
    // 处理路由数据 包含路由角色权限
    setRouterArr () {
      // 获取用户数据
      this.userData = this.$store.getters.userData
      this.routersArr = JSON.parse(JSON.stringify(this.routes))
    },
    // 导航跳转
    menuNav (name) {
      this.routerPush(name)
    },
    // 父级栏目展开收缩事件
    open (name) {
      this.openNames = ["" + name + ""]
    },
    // 下拉菜单跳转
    dropdownNav (name) {
      this.routerPush(name)
    },
    // tab切换跳转
    tabNav (name) {
      this.routerPush(name)
    },
    // 路由跳转
    routerPush (name) {
      let itemRouter = this.ruleValidate(constantRoutes, name)
      console.log(itemRouter)
      if (itemRouter.productId) {
        // console.log(2222)
        // this.$router.push({ name: name });
        // return false;
        this.getOpenStatus(itemRouter.productId, () => {
          this.$router.push({ name: name })
        })
      } else {
        this.$router.push({ name: name, })
      }

      this.$nextTick(() => {
        // let w = document.getElementById("tabsDiv").offsetWidth;
        // let zw = document.getElementById("tabsNav").offsetWidth;
        // if (w > zw) {
        //   this.tabSwitch = true;
        // }
      })
    },

    //  返回当前路由对象
    ruleValidate (list, name) {
      let flag = true
      var obg = {}
      function judgeChildren (list) {
        list.forEach(e => {
          if (!flag) {
            return
          }
          if (e.name == name) {
            obg = e
            flag = false
            return
          } else if (e.children && e.children.length) {
            judgeChildren(e.children)
          }
        })
      }
      judgeChildren(list)
      return obg
    },

    //  获取当前产品的开通状态
    getOpenStatus (productCode, fn) {
      httpAgent({
        url: `/agent/product/status`,
        method: "get",
        data: { productCode }
      }).then((response) => {
        // if (response.success) {
        //   fn(response.data)
        // } else {
        //   this.$message({
        //     message: response.msg,
        //     type: "error",
        //   })
        // }
        if (response == 1) {
          fn()
        } else {
          this.$router.push({ name: 'empty' })
          this.$message({
            message: '抱歉，你还没有使用产品的权限',
            type: "error",
          })
        }
      })
    },


    // tab关闭
    tabNavClose (item, index) {
      let arr = this.$store.getters.routerArr
      // 判断是否是首页
      if (item.name !== this.$indexPage) {
        this.$store.dispatch("tagsView/delRouter", index)
        if (index !== 0) {
          this.$router.push({
            name: arr[index - 1].name,
          })
        }
      }
      this.$nextTick(() => {
        // let w = document.getElementById("tabsDiv").offsetWidth;
        // let zw = document.getElementById("tabsNav").offsetWidth;
        // if (w < zw) {
        //   this.tabSwitch = false;
        // }
      })
    },
    // tab最右侧下拉框右键选中
    tabRightClick (type) {
      let arr = this.$store.getters.routerArr
      this.tabSwitch = false
      switch (type) {
        case "qt":
          for (let i = arr.length - 1; i > -1; i--) {
            if (arr[i].name !== this.activeName) {
              this.$store.dispatch("tagsView/delRouter", i)
            }
          }
          break
        case "qb":
          if (arr.length === 1) {
            if (this.$route.name !== this.$indexPage) {
              for (let i = arr.length - 1; i > -1; i--) {
                this.$store.dispatch("tagsView/delRouter", i)
              }
            }
          } else {
            for (let i = arr.length - 1; i > -1; i--) {
              this.$store.dispatch("tagsView/delRouter", i)
            }
          }
          break
      }
    },
    // 窗口最大化
    maxWindow () {
      if (this.isMaxWindow) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
        this.isMaxWindow = false
      } else {
        let element = document.documentElement
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
        this.isMaxWindow = true
      }
    },
    // 向左切换
    tabLeft () {
      this.transform = "translateX(0px)"
    },
    // 向右切换
    tabRight () {
      let w = document.getElementById("tabsDiv").offsetWidth
      let zw = document.getElementById("tabsNav").offsetWidth
      if (w > zw) {
        let s = -(w - zw)
        this.transform = "translateX(" + s + "px)"
      }
    },
    // 页面刷新后 将vuex路由数据存储到本地
    saveState () {
      let arr = this.$store.getters.routerArr
      let arr1 = []
      for (let v of arr) {
        let item = {
          fullPath: v.fullPath,
          meta: v.meta,
          name: v.name,
          path: v.path,
        }
        arr1.push(item)
      }
      localStorage.setItem("dataRouter", JSON.stringify(arr1))
    },
    // 主题切换
    themeSwitch (type) {
      if (type === 0) {
        this.themeType = "dark"
        this.logoImg = lightImg
      } else {
        this.themeType = "light"
        this.logoImg = darkImg
      }
    },
    // 页面刷新
    refresh () {
      // 先隐藏
      this.isRouterViewShow = false
      // $nextTick() 将回调延迟到下次 DOM 更新循环之后执行
      this.$nextTick(() => {
        this.isRouterViewShow = true
      })
    },
    // 个人设置功能
    personalSettings (name) {
      if (name === "logout") {
        // httpAjax({
        //   url: `/services/auth/logout`,
        //   method: "post",
        // }).then((response) => {
        //   if (response.success) {
        //     this.logoutFun()
        //   } else {
        //     this.$message({
        //       message: response.msg,
        //       type: 'error'
        //     })
        //   }
        // })
        //this.$store.dispatch("user/logout").then(() => {
        this.$router.push({ name: "register" })
        this.$message({
          message: '退出成功',
          type: 'success',
          offset: 80
        })
        localStorage.removeItem('userToken')
        localStorage.removeItem('userData')
        this.$store.dispatch('user/setIsLogin', false)
        //this.logoutPostMessage()//通知代理系统退出成功
        //})
      } else if (name === 'userCenter') {
        this.$router.push({
          name: 'homePage',
        })
      }
    },
    // 企业认证
    goCompanyRegister () {
      this.$router.push({
        name: 'certification',
        params: { menuIndex: 3 }
      })
    },
    // 帮助中心
    helpCenter () {
      this.$router.push({
        name: 'help'
      })
    },

    async logoutFun () {
      await this.$store.dispatch("user/logout")
      this.$router.push({
        name: this.$loginPage,
      })
    },



    // 获取船公司
    getVgmCarrier () {
      httpAjax({
        url: `/services/base/data/vgm/carrier`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          localStorage.setItem('vgmCarrierData', JSON.stringify(response.data))
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      })
    },

    // 获取船公司
    getCpsCarrier () {
      httpAjax({
        url: `/services/base/data/cps/carrier`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          localStorage.setItem('cpsCarrierData', JSON.stringify(response.data))
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      })
    },
    //获取当前域名企业信息
    getDomainInfo () {
      httpAgent({
        url: `${location.hostname == 'localhost' ? 'http://gateway.eline56.test' : ''}/agent/config/preGet`,
        method: "get",
      }).then((res) => {
        if (res.id) {
          if(res.companyLogo){
            if(res.companyLogo.indexOf('http') > -1){
              this.companyLogo = res.companyLogo
            }else{
              this.companyLogo = 'https://' + res.companyLogo
            }
          }
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = this.companyLogo;
          document.getElementsByTagName('head')[0].appendChild(link);
        }else{
          this.$router.push({
            name:'notFind'
          })
        }
      })
    },
    goHome(){
      this.$router.push({ name: 'register', })
    }
  },
  watch: {
    // 监听路由跳转
    $route () {
      this.activeName = this.$route.name
      this.openNames = []
      this.openNames.push(this.$route.meta.fuName)
      this.$nextTick(() => {
        this.$refs.side_menu.updateOpened()
        this.$refs.side_menu.updateActiveName()
        this.saveState()
      })
    },
    // 监听路由数组改变
    getRouterArrVuex (val) {
      if (val.length < 1) {
        this.$router.push({
          name: this.$indexPage,
        })
      }
      // 动态监听路由变化 自动滚动多页签导航
      this.$nextTick(() => {
        // 修复退出登录 页面报错
        if (document.getElementById("tabsNav")) {
          let zw = document.getElementById("tabsNav").offsetWidth // 总宽度
          let w = document.getElementById("tabsDiv").offsetWidth // 导航宽度
          if (w > zw) {
            let s = -(w - zw)
            this.transform = "translateX(" + s + "px)"
          } else {
            this.tabLeft()
          }
        }
      })
    },
  },
  filters: {},
};
</script>

<style lang="less">
@import "main";
</style>
